<template>
    <div>
        <!-- <client-stats /> -->
        <user-stats />
    </div>
</template>
<script>
import moment from 'moment'
import ClientStats from '../components/ClientStats'
import UserStats from '../components/UserStats'
export default {
    name: 'Dashboard',
    components: {
        ClientStats,
        UserStats
    },
    data(){
        return {
        }
    },
    methods: {

    }
}
</script>
<style>
</style>



